import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/bovenlokaliteitperinfrastructuur/";

const bovenLokaliteitPerInfrastructuurApi = {
	get(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptySportinfrastructuurInDeBuurt() {
		const serviceUrl = prependRoot(routePrefix + "sportinfrastructuurindebuurt", getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(bovenLokaliteit, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, {
			item: bovenLokaliteit,
			documenten
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	delete(infraInDeBuurtId) {
		const serviceUrl = prependRoot(routePrefix + infraInDeBuurtId, getApiRoot());
		return axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	validateBovenLokaliteitPerInfrastructuur(bovenLokaliteitPerInfrastructuur) {
		const serviceUrl = prependRoot(routePrefix + "validateSportInfrastructuurInDeBuurt", getApiRoot());
		return axios.put(serviceUrl, bovenLokaliteitPerInfrastructuur, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default bovenLokaliteitPerInfrastructuurApi;